import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { isSdfCardFlow } from '../../config/app-config';
import { AppSummarySectionConfig, SectionItem } from '../../app.models';

@Component({
    selector: 'app-summary-section',
    templateUrl: './summary-section.component.html',
    styleUrls: ['./summary-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SummarySectionComponent {
  isSdfCardFlow = false;
  private _config?: AppSummarySectionConfig;
  public get config() {
    return this._config!;
  }

  @Input() displayTitle: boolean = true;
  private _title?: SectionItem;
  @Input() public set title(title: SectionItem | any) {
    this._title = title;
  }
  public get title() {
    return this._config?.title || this._title!;
  }

  private _footer?: SectionItem;
  @Input() displayFooter: boolean = true;
  @Input() public set footer(footer: SectionItem | any) {
    this._footer = footer;
  }
  public get footer() {
    return this._config?.footer || this._footer!;
  }

  private _items?: SectionItem[] | any = [];
  @Input() public set items(items: SectionItem[]) {
    this._items = items;
  }
  public get items() {
    return this._config?.items || this._items!;
  }

  constructor() {
    this.isSdfCardFlow = isSdfCardFlow;
  }
}
